import * as React from 'react';

const WebpageSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 48 48" {...props}>
        <g
            id="webpage_svg__Webpage"
            stroke="#1D0A32"
            strokeWidth={2}
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path
                id="webpage_svg__Rectangle"
                transform="rotate(180 24 24)"
                d="M1 4h46v40H1z"
            />
            <circle id="webpage_svg__Oval" cx={8} cy={10} r={1} />
            <circle id="webpage_svg__Oval-Copy" cx={14} cy={10} r={1} />
            <circle id="webpage_svg__Oval-Copy-2" cx={20} cy={10} r={1} />
            <path id="webpage_svg__Path-19" d="M25 10h16" />
            <path
                id="webpage_svg__Path"
                transform="matrix(-1 0 0 1 48 0)"
                d="M7 27V16h34v22H7v-5"
            />
        </g>
    </svg>
);

WebpageSvg.displayName = 'WebpageSvg';
export default WebpageSvg;
